"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitCopiedRegions = exports.getAllLabsData = exports.getAllStatesData = exports.editDetails = exports.createUpdateRegion = exports.submitCompanies = exports.getCitiesData = exports.createUserLogistic = exports.userlogisticsMobileAndEmailExist = exports.fetchUserLogisticsList = void 0;
var react_hot_toast_1 = require("react-hot-toast");
var api_service_1 = require("../../../api/api_service");
var array_helpers_1 = require("../../../utils/array_helpers");
var fetchUserLogisticsList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .get({
            endPoint: api_service_1.api_service.api_urls.USER_LOGISTICS_LIST,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (response) {
            var _a;
            if (response.status === 200) {
                return resolve((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data);
            }
            var erroMessage = response.data
                ? response.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (err) {
            return reject(err);
        });
    });
};
exports.fetchUserLogisticsList = fetchUserLogisticsList;
var userlogisticsMobileAndEmailExist = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .get({
            endPoint: "".concat(api_service_1.api_service.api_urls.MOBILEANDEMAILVALIDATE),
            payLoad: payload,
            domain: process.env.APPROVAL_BASEURL,
        })
            .then(function (res) {
            return resolve(res);
        })
            .catch(function (e) {
            return reject(e.message);
        });
    });
};
exports.userlogisticsMobileAndEmailExist = userlogisticsMobileAndEmailExist;
var createUserLogistic = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.CREATEUSERLOGISTIC,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data);
            }
            throw response.data.message;
        })
            .catch(function (err) {
            return reject(err);
        });
    });
};
exports.createUserLogistic = createUserLogistic;
var getCitiesData = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.CITIES,
            payLoad: payload,
            domain: process.env.VENDOR_BASE_URL
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data.data);
            }
            throw response.data.message;
        })
            .catch(function (err) {
            return reject(err);
        });
    });
};
exports.getCitiesData = getCitiesData;
var submitCompanies = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.SUBMIT_COMPANIES,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data.message);
            }
            throw response.data.message;
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.message);
            return reject(err);
        });
    });
};
exports.submitCompanies = submitCompanies;
var createUpdateRegion = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.CREATE_UPDATE_REGION,
            domain: process.env.APPROVAL_BASEURL,
            payLoad: payload,
        })
            .then(function (response) {
            return resolve(response.data);
        })
            .catch(function (err) {
            return reject(err);
        });
    });
};
exports.createUpdateRegion = createUpdateRegion;
var editDetails = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .get({
            endPoint: "".concat(api_service_1.api_service.api_urls.CREATE_UPDATE_REGION, "?user_id=").concat(payload),
            domain: process.env.APPROVAL_BASEURL,
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data);
            }
            throw response.data.message;
        })
            .catch(function (err) {
            return reject(err);
        });
    });
};
exports.editDetails = editDetails;
var getAllStatesData = function (payLoad) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, new Promise(function (resolve, reject) {
                api_service_1.api_service
                    .get({
                    endPoint: api_service_1.api_service.api_urls.STATE,
                    payLoad: payLoad,
                    domain: process.env.VENDOR_BASE_URL,
                })
                    .then(function (response) {
                    if (response.status === 200) {
                        var stateResponse = (0, array_helpers_1.convertLabelAndValueStates)(response.data.data.states);
                        var res = [];
                        res.push(stateResponse);
                        return resolve(res);
                    }
                })
                    .catch(function (err) {
                    return reject(err.message);
                });
            })];
    });
}); };
exports.getAllStatesData = getAllStatesData;
var getAllLabsData = function (payLoad) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, new Promise(function (resolve, reject) {
                api_service_1.api_service
                    .post({
                    endPoint: api_service_1.api_service.api_urls.Lab_Master_List,
                    domain: process.env.APPROVAL_BASEURL,
                    payLoad: payLoad
                })
                    .then(function (response) {
                    if (response.status === 200) {
                        var res = [];
                        res.push(response.data.data.result);
                        var labsData = response.data.data.result;
                        var convertedlabCodeResponse = (0, array_helpers_1.convertLabCoderesponse)(labsData);
                        return resolve(convertedlabCodeResponse);
                    }
                })
                    .catch(function (err) {
                    react_hot_toast_1.default.error(err.message);
                    return reject(err.message);
                });
            })];
    });
}); };
exports.getAllLabsData = getAllLabsData;
var submitCopiedRegions = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, new Promise(function (resolve, reject) {
                api_service_1.api_service
                    .post({
                    endPoint: api_service_1.api_service.api_urls.SUBMIT_COPY_REGION,
                    domain: process.env.APPROVAL_BASEURL
                })
                    .then(function (response) {
                    if (response.status === 200) {
                        react_hot_toast_1.default.success('User regions updated successfully', { duration: 3000 });
                        resolve(response);
                    }
                    react_hot_toast_1.default.error(response.message, { duration: 2000 });
                })
                    .catch(function (err) {
                    react_hot_toast_1.default.error(err.message);
                    return reject(err.message);
                });
            })];
    });
}); };
exports.submitCopiedRegions = submitCopiedRegions;
